import React from 'react';
import { content, SupportedLocale } from '../lib/content';

type FooterProps = {
  locale?: SupportedLocale;
  onOpenPrivacy?: () => void;
  onOpenCookies?: () => void;
  onOpenCookieSettings?: () => void;
  onOpenTerms?: () => void;
};

const BRAND_NAMES: Record<SupportedLocale, string> = {
  pl: 'Pieńkowski – Kancelaria Adwokacka',
  en: 'Pieńkowski – Law Office',
  es: 'Pieńkowski – Despacho de Abogados',
};

const COOKIE_SETTINGS_LABELS: Record<SupportedLocale, string> = {
  pl: 'Ustawienia cookies',
  en: 'Cookie settings',
  es: 'Configuración de cookies',
};

export const Footer: React.FC<FooterProps> = ({
  locale = 'pl',
  onOpenPrivacy,
  onOpenCookies,
  onOpenCookieSettings,
  onOpenTerms,
}) => {
  const t = content[locale];
  const brandName = BRAND_NAMES[locale];

  const openPrivacy = () => {
    onOpenPrivacy?.();
    window.dispatchEvent(new Event('legal:privacy'));
  };

  const openCookies = () => {
    onOpenCookies?.();
  };

  const openCookieSettings = () => {
    onOpenCookieSettings?.();
  };

  const openTerms = () => {
    onOpenTerms?.();
  };

  return (
    <footer className="site-footer">
      <div className="container footer-inner">
        {/* BRAND */}
        <div className="footer-brand">
          <div className="brand-mark small" aria-hidden="true">
            <img src="/Logo.png" alt="" />
          </div>
          <div className="brand-text">
            <span className="brand-line">{brandName}</span>
          </div>
        </div>

        <div className="footer-meta">
          <span className="footer-copy">{t.footer.copyright}</span>

          <div className="footer-links">
            <button type="button" className="link-button" onClick={openPrivacy}>
              {t.footer.privacy}
            </button>

            <button type="button" className="link-button" onClick={openCookieSettings}>
              {COOKIE_SETTINGS_LABELS[locale]}
            </button>
          </div>
        </div>

        <div className="footer-social">
          {t.footer.socials.map((item) => (
            <a key={item.name} className="social-link" href={item.href}>
              {item.name}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
};